import { Resume } from '@/models/Resume';
import { deserialize, plainToClass } from 'class-transformer';

/* eslint @typescript-eslint/no-var-requires: "off" */

export default class ResumeLoader {

    load(): Resume {
        // const json = require('./../../resume.json');
        const json = require('@/../resume.json');
        const resume = plainToClass(Resume, json)    
        return resume
    }

    static load(): Resume {
        const loader = new ResumeLoader()
        return loader.load()
    }
}